export default "__VITE_ASSET__e3f11957__"